import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import { Navigation } from './components/Navigation';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import AddressesPage from './pages/AddressesPage';
import GalleryPage from './pages/GalleryPage';
import ContactsPage from './pages/ContactsPage';
import AdminPage from './pages/AdminPage';
import MasterPage from './pages/MasterPage';
import SuccessPage from './pages/SuccessPage';
import FailurePage from './pages/FailurePage';
import ChatWidget from './components/ChatWidget';
import Footer from './components/Footer';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isPublicPage = ['/', '/about', '/addresses', '/gallery', '/contacts'].includes(location.pathname);
  const isAdminOrMasterPage = location.pathname === '/admin' || location.pathname === '/master';
  
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-200 flex flex-col">
      {/* Show Navigation only on public pages, hide on admin/master */}
      {!isAdminOrMasterPage && <Navigation />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/addresses" element={<AddressesPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/master" element={<MasterPage />} />
          <Route path="/payment/success" element={<SuccessPage />} />
          <Route path="/payment/failure" element={<FailurePage />} />
        </Routes>
      </main>
      
      {/* Footer на всех публичных страницах */}
      {isPublicPage && <Footer />}
      
      {/* AI Chat Widget на всех публичных страницах */}
      {isPublicPage && <ChatWidget />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
